import React from "react";

/**
 * Blocking overlay shown when the protected view must be hidden:
 *  - full screen required / return to full screen
 *  - window blurred, tab hidden, DevTools open
 *  - access revoked (focus loss limit / capture detected)
 *
 * Renders nothing when not blurred. Text is fully overridable so it can pull
 * from the existing DocumentRPD translations map.
 */
export function ProtectionOverlay({
  visible,
  title,
  message,
  actionLabel,
  onAction,
}) {
  if (!visible) return null;

  return (
    <div className="dp-overlay" onContextMenu={(e) => e.preventDefault()}>
      <div className="dp-overlay-card">
        {title ? <h4 className="dp-overlay-title">{title}</h4> : null}
        {message ? <p className="dp-overlay-message">{message}</p> : null}
        {actionLabel && typeof onAction === "function" ? (
          <button type="button" className="dp-overlay-btn" onClick={onAction}>
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default ProtectionOverlay;
